/** App-wide stacking order — sidebar flyout must sit above in-table sticky columns. */
export const Z_TABLE_STICKY_COL_BODY = 11;
export const Z_TABLE_STICKY_COL_HEAD = 12;
/** Frozen report header row (transaction reports). */
export const Z_TABLE_STICKY_HEAD_ROW = 10;
/** Header cell at intersection of frozen row + frozen column. */
export const Z_TABLE_STICKY_HEAD_CORNER = 13;
export const Z_SIDEBAR = 1250;
export const Z_SIDEBAR_FLYOUT = 1500;
